import { render, staticRenderFns } from "./AssayImages.vue?vue&type=template&id=04e68d99&scoped=true"
import script from "./AssayImages.vue?vue&type=script&lang=js"
export * from "./AssayImages.vue?vue&type=script&lang=js"
import style0 from "./AssayImages.vue?vue&type=style&index=0&id=04e68d99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e68d99",
  null
  
)

export default component.exports